import React from 'react';
import { useCustomerDetails } from '../api/getCustomerDetails';

export const DisplayName = ({
  userId,
  showFirstName = true,
  showLastName = true,
  fullNameOnly = false,
  fallback = 'User',
  className = '',
}) => {
  const { data, isLoading } = useCustomerDetails({ id: userId });

  if (isLoading) {
    return <div className={`h-4 w-24 bg-gray-300 dark:bg-gray-700 animate-pulse rounded ${className}`} />;
  }

  const user = data?.userDetails || {};
  const { firstName = '', lastName = '' } = user;

  console.log(data)

  let displayName = fallback;

  if (fullNameOnly && (firstName || lastName)) {
    displayName = `${firstName} ${lastName}`.trim();
  } else if (showFirstName && showLastName) {
    displayName = `${firstName} ${lastName}`.trim();
  } else if (showFirstName) {
    displayName = firstName || fallback;
  } else if (showLastName) {
    displayName = lastName || fallback;
  }

  return <span className={`text-sm font-medium capitalize text-white truncate ${className}`}>{displayName}</span>;
};
